
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16C31.99 7.168 24.832.01 16 0zm.333 6.667a2 2 0 11-.001 4.001 2 2 0 01.001-4.001zm3 18H14A1.334 1.334 0 0114 22h1c.184 0 .333-.15.333-.333v-6a.333.333 0 00-.333-.334h-1a1.334 1.334 0 010-2.666h1.333A2.666 2.666 0 0118 15.333v6.334c0 .184.15.333.333.333h1a1.334 1.334 0 010 2.667z"}})])
          )
        }
      }
    